<template src="@/templates/profile/profile.html"></template>

<script>
import { mapActions } from "vuex";
import CheckInfo from "@/components/profile/CheckInfo";
import ProfileModel from "@/models/profileModel";
import Disclaimer from "@/components/disclaimer/Disclaimer";
import ClearanceCheckCollection from "@/collections/clearanceCheckCollection";
import SocialMedia from "@/components/socialMedia";
import { moments } from "@/utilities/moments";
import moment from "moment";

export default {
  name: "Profile",
  components: { Disclaimer, CheckInfo, SocialMedia },
  data() {
    return {
      profileModel: new ProfileModel(),
      clearanceCheckCollection: new ClearanceCheckCollection(),
      jwt: localStorage.getItem("jwt"),
      viewClearanceCheckInfo: false,
      checkInfoTitle: "",
      checkInfo: "",
      information: "",
      checkViewPopUp: true,
      categories: [],
      noneProvided: false,
      status: {
        isValidPoliceCheck: "",
        policeCheck: "loading",
        isValidWWCC: "",
        wwcc: "loading",
      },
    };
  },
  computed: {
    languageList() {
      if (this.profileModel.languages) {
        return this.profileModel.languages.split(",");
      }
      return [];
    },
  },
  mounted() {
    Event.$on("hideCheckInfoViewComp", () => {
      this.viewClearanceCheckInfo = false;
    });
  },
  created: function () {
    this.initialSetup();
  },
  beforeDestroy() {
    this.viewClearanceCheckInfo = false;
  },
  methods: {
    ...mapActions(["updateHideAll", "updateBackButton"]),
    initialSetup() {
      this.getProfileDetail();
      this.updateBackButton(false);
      this.updateHideAll();
    },
    getProfileDetail() {
      this.$vs.loading();
      let profileObj = new ProfileModel();
      profileObj
        .fetch({
          url: this.$interpretersApiUrl + profileObj.getRoute("fetch"),
          headers: { Bearer: this.jwt },
        })
        .then((res) => {
          let response = res.response.data;
          this.profileModel = response.data;
          this.getClearanceCheck();

          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log("error status code");
          console.log(error.response.response.status);
          if (error.response) {
            if (error.response.response.status == "401") {
              Event.$emit("tokenExpiredLogout");
            }
          }
        });
    },
    getClearanceCheck() {
      this.clearanceCheckCollection
        .getProfileList()
        .then((res) => {
          this.clearanceCheckCollection.models = res.response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.clearanceCheckCollection
        .getCategoryList()
        .then((res) => {
          this.categories = res.response.data;

          this.categories.forEach((category) => {
            let counter = 0;
            category.childMenu.forEach((menu) => {
              if (menu.valid_to == null) {
                counter++;

                console.log("counter");
                console.log(counter);
                console.log(category.childMenu.length);
              }
            });

            if (counter == category.childMenu.length) {
              this.noneProvided = true;
            }
          });

          this.clearanceCheckCollection
            .getInformation()
            .then((res) => {
              this.information = res.response.data.value;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showCheckInfo(title, info) {
      this.viewClearanceCheckInfo = true;
      this.checkInfoTitle = title;
      this.checkInfo = info;
    },
    isExpired(valid_to) {
      let dateNow = moment().format("YYYY-MM-DD");
      let validTo = moment(valid_to).format("YYYY-MM-DD");
      let dateNowUnix = moments.formatDateTimeAsUnix(dateNow);
      let validToUnix = moments.formatDateTimeAsUnix(validTo);

      return validToUnix < dateNowUnix;
    },
  },
};
</script>
